module.exports = "/images/png-fileicon.svg?3d740104e843329e8708861c5669f4da";